import { render, staticRenderFns } from "./SuiteTestCase.vue?vue&type=template&id=79881d3a&scoped=true&"
import script from "./SuiteTestCase.vue?vue&type=script&lang=js&"
export * from "./SuiteTestCase.vue?vue&type=script&lang=js&"
import style0 from "./SuiteTestCase.vue?vue&type=style&index=0&id=79881d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79881d3a",
  null
  
)

export default component.exports